export function getSearchParams() {
    return new URLSearchParams(location.search);
}
export function removeSearchParam(name) {
    const sp = getSearchParams();
    sp.delete(name);
    const strQ = sp.size ? `?${sp}` : '';
    history.replaceState(undefined, '', new URL(location.pathname + strQ, location.origin));
}
